import { constantRoutes } from '@/router'
import Layout from '@/layout'

export function filterAsyncRoutes(userRoutes) {
  const res = []
  userRoutes.forEach(userRoute => {
    const tmp = {
      path: userRoute.path,
      component: userRoute.component === 'Layout' ? Layout : (resolve) => require([`@/views/${userRoute.component}`], resolve),
      name: userRoute.route_name,
      meta: {
        title: userRoute.name,
        icon: userRoute.icon
      }
    }
    if (userRoute.redirect !== '') {
      tmp.redirect = userRoute.redirect
    }
    if (Number(userRoute.is_cache) !== 1) {
      tmp.meta.noCache = true
    }
    if (Number(userRoute.is_show) !== 1) {
      tmp.hidden = true
    }
    if (userRoute.children && userRoute.children.length > 0) {
      tmp.children = filterAsyncRoutes(userRoute.children)
    }
    res.push(tmp)
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, routes) {
    return new Promise(resolve => {
      let accessedRoutes = filterAsyncRoutes(routes)
      accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  clearRoutes({ commit }) {
    return new Promise(resolve => {
      commit('SET_ROUTES', [])
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
